import React from "react";


const LastBanner = () => {
    return (
        <div
            id="carouselExampleAutoplaying"
            className="carousel mb-[1rem]  "
            data-bs-ride="carousel"
        >

            <div className=" carousel-inner ">
                <div className="carousel-item active relative  ">
                    <img src='https://ik.imagekit.io/mctozv7td/Mirpur%20Jewelers/meenapic/mirpur%20derby%20necklace.png?updatedAt=1712149130867' alt="Jewellery Banner" width="1600" height="900" className="" />
                </div>

            </div>
        </div>
    );
};

export default LastBanner;
